import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './utils/flexible.js'
import axios from 'axios'
import Qs from 'qs'
import VueClipboard from 'vue-clipboard2' //复制
import 'vue2-toast/lib/toast.css'
import Toast from 'vue2-toast'
import Calendar from 'vue-mobile-calendar'//日期组件
import Datepick from 'vue2-datepick';
import VueQriously from 'vue-qriously' //二维码
import { DatetimePicker } from 'mint-ui';
import * as filters from './utils/filters.js'
import 'mint-ui/lib/style.css'

Vue.use(VueQriously)

import VueI18n from 'vue-i18n'
import md5 from 'js-md5'
import sha1 from 'js-sha1'

Vue.use(VueI18n)
Vue.use(Calendar)
Vue.use(Datepick);

Vue.prototype.$md5 = md5;
Vue.prototype.$sha1 = sha1;

Vue.component(DatetimePicker.name, DatetimePicker);

Vue.use(Toast,{
  type: 'center',
  duration: 3000,
  wordWrap: true,
})

if(localStorage.getItem('language') == null){
  localStorage.setItem('language','en')
}
const i18n = new VueI18n({
	locale: window.localStorage.getItem('language') == null ? "en" : window.localStorage.getItem('language'),
	messages: {
    'zh': require('./utils/lang/zh'), // 中文语言包
    'tw': require('./utils/lang/tw'), // 繁体语言包
		'en': require('./utils/lang/en'), // 英文语言包
    'jp': require('./utils/lang/jp'), // 日语语言包
    'es': require('./utils/lang/es'), // 西班牙语言包
    'th': require('./utils/lang/th'), // 泰语言包
		'vn': require('./utils/lang/vn'), // 越南语言包
    'de': require('./utils/lang/de'), // 德语语言包
    'fr': require('./utils/lang/fr'), // 法语语言包
    'kr': require('./utils/lang/kr'), // 韩语语言包
    'ar': require('./utils/lang/alb'), // 阿拉伯语言包
	}
})

Vue.config.productionTip = false

axios.defaults.timeout = 15000 // 请求超时

// axios.defaults.baseURL = 'http://45.77.254.9:81'  // api 即上面 vue.config.js 中配置的地址
axios.defaults.baseURL = window.GLOBAL.HOST  // api 即上面 vue.config.js 中配置的地址
axios.defaults.transformRequest = [data => {
  return Qs.stringify(data)
}]

Vue.prototype.domain = window.GLOBAL.HOST;
Vue.prototype.project = window.GLOBAL.downLoad;

Vue.prototype.socket_url = window.GLOBAL.webSocket;
Vue.prototype.hkdz = window.GLOBAL.hkdz;
Vue.prototype.syName = window.GLOBAL.syName;
document.title = window.GLOBAL.title;

axios.interceptors.request.use(function(config){
  store.state.isLoad = false; //在请求发出之前进行一些操作
  if(config.method === 'post') {
    config.data = {
      lang: localStorage.getItem('language') || 'en',
      app: 'h5',
      rtoken: randomRange(6,16),
      token: localStorage.getItem('token') || 1,
      ...config.data
    }
  }else if (config.method === 'get') {
    config.params = {
      lang: localStorage.getItem('language') || 'en',
      app: 'h5',
      rtoken: randomRange(6,16),
      token: localStorage.getItem('token') || '',
      ...config.params
    }
  }
  return config
})

//定义一个响应拦截器
axios.interceptors.response.use((config) =>{
  store.state.isLoad = false;//在这里对返回的数据进行处理
  return config
},(err) =>{
  return Promise.reject(err)
})

Vue.prototype.$ajax = axios

Vue.use(VueClipboard)

Object.keys(filters).forEach(key=>{
  Vue.filter(key,filters[key])//插入过滤器名和对应方法
})

router.beforeEach((to, from, next) => {
  const fullPath = to.fullPath;
  var reloaded = localStorage.getItem('reloaded') || '';
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
      if (localStorage.getItem('token')) {  // 通过vuex state获取当前的token是否存在
          next();
          if(reloaded == '' && (to.name == 'kline' || to.name == 'contractTransaction')){
            location.reload();
            localStorage.setItem('reloaded','yes');
          }
      }else {
          next({
              path: '/login',
              query: {redirect: fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
          })
      }
  }else {
    next();
  }
})
// 网站主题
var css;
var theme = JSON.parse(localStorage.getItem('theme'));
css = document.createElement('link');
css.id = 'themestyle',
css.type = 'text/css';
css.rel = 'stylesheet';
var headNode = document.getElementsByTagName("head")[0];
headNode.appendChild(css);
if(theme){
	$('#themestyle').attr('href','/static/css/theme.css');
}else{
	$('#themestyle').attr('href','');
}
function randomRange(min,max) {
	var returnStr = "",
	range = (max ? Math.round(Math.random() * (max-min)) + min : min),
	arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
	for(var i=0; i<range; i++){
		var index = Math.round(Math.random() * (arr.length-1));
		returnStr += arr[index];
	}
	return returnStr;
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js